module.exports = __webpack_public_path__ + "static/trioimg1-4491f779e897b1ed09755184aaae8c77.jpg";